import React, { FC } from 'react';
import { useTranslate } from '@im/react-localization';
import { Form } from 'src/components/Form';
import {
  useCustomerGroupUpdate,
  CustomerGroupUpdateRequest,
} from '../hooks/customerGroupMutations';
import {
  DescriptionField,
  GetBasicFieldValidations as getValidations,
} from '../CustomerGroups/CustomerGroupBasicFields';

export interface CustomerGroupFormProps {
  customerGroup: any;
  isProductGroups?: boolean;
  onClose: (result?: any) => void;
}

const EditCustomerGroupForm: FC<CustomerGroupFormProps> = ({
  customerGroup,
  isProductGroups,
  onClose,
}) => {
  const mutation = useCustomerGroupUpdate(isProductGroups);
  const translate = useTranslate();
  const formProps = {
    initialState: customerGroup,
    mutation,
    onClose,
    submitLabel: translate('CustomerGroups.updateSubmitLabel'),
    title: translate(
      isProductGroups
        ? 'ProductGroups.EditProductGroup'
        : 'CustomerGroups.updateTitle'
    ),
    validations: getValidations(),
  };

  return (
    <Form<CustomerGroupUpdateRequest>
      fields={DescriptionField}
      getErrorMsg={(error, msg) => {
        if (error.response?.statusCode !== 400) {
          return msg;
        }
      }}
      {...formProps}
    />
  );
};

export default EditCustomerGroupForm;
